import { render, staticRenderFns } from "./LeadGen.vue?vue&type=template&id=1b00dd04&scoped=true&"
import script from "./LeadGen.vue?vue&type=script&lang=js&"
export * from "./LeadGen.vue?vue&type=script&lang=js&"
import style0 from "./LeadGen.vue?vue&type=style&index=0&id=1b00dd04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00dd04",
  null
  
)

/* custom blocks */
import block0 from "./LeadGen.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports